export default __webpack_public_path__ + "static/media/sky-bg-desktop@2x.fe009be5.png";